import type { BoundActions, HookFunction, StoreActionApi } from 'react-sweet-state';
import { createStore, createHook } from 'react-sweet-state';

const Store = createStore({
	initialState: {
		isAutoConverted: false,
	},
	actions: {
		setIsAutoConverted:
			(
				isAutoConverted: any,
			): (({
				setState,
			}: StoreActionApi<{
				isAutoConverted: boolean;
			}>) => void) =>
			({ setState }) => {
				setState({
					isAutoConverted,
				});
			},
	},
	name: 'isAutoConverted',
});

const getAutoConvertState = (state: { isAutoConverted: boolean }) => {
	return state.isAutoConverted;
};

export const useAutoConvertState: HookFunction<
	boolean,
	BoundActions<
		{
			isAutoConverted: boolean;
		},
		{
			setIsAutoConverted: (isAutoConverted: any) => ({
				setState,
			}: StoreActionApi<{
				isAutoConverted: boolean;
			}>) => void;
		}
	>,
	void
> = createHook(Store, {
	selector: getAutoConvertState,
});
